var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DDD1C0",
    fillRule: "nonzero",
    d: "M24 8.13c-8.828 0-16 7.092-16 15.82 0 8.73 7.172 15.82 16 15.82s16-7.09 16-15.82c0-8.728-7.172-15.82-16-15.82zm0 1.438c8.042 0 14.545 6.431 14.545 14.382 0 7.952-6.503 14.382-14.545 14.382S9.455 31.902 9.455 23.95C9.455 16 15.958 9.568 24 9.568zm0 5.753c-2.803 0-5.09 2.262-5.09 5.034-.005.26.133.5.36.631.226.131.506.131.733 0a.718.718 0 0 0 .36-.631c0-1.994 1.62-3.596 3.637-3.596s3.636 1.602 3.636 3.596c0 1.224-.508 2.09-1.295 2.91-.787.82-1.85 1.533-2.796 2.281a.716.716 0 0 0-.272.562v2.157c-.004.26.134.5.36.631.227.131.507.131.734 0a.718.718 0 0 0 .36-.63v-1.81c.83-.634 1.808-1.316 2.66-2.202.94-.98 1.704-2.254 1.704-3.9 0-2.77-2.288-5.033-5.091-5.033zm0 15.101c-.602 0-1.09.483-1.09 1.079s.488 1.079 1.09 1.079c.602 0 1.09-.483 1.09-1.079s-.488-1.079-1.09-1.079z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLight);
export default __webpack_public_path__ + "static/media/info-light.e509f20f3307ca3d2815b85d3c78e510.svg";
export { ForwardRef as ReactComponent };